import { LANG_REGEX } from '../constants';

const getLocaleFromUrl = () => {
  const { pathname } = window.location;

  return pathname.match(LANG_REGEX) && pathname.match(LANG_REGEX)[0].replace(/\//g, '');
};

export default getLocaleFromUrl;
